export const LABELS = {
	about: "About",
	productsAndService: "Products & Service",
	news: "News",
	contact: "Contact",
	privacyPolicy: "Privacy Policy",
};

export const ROUTES = {
	HOME: "/",
	ABOUT: "/about",
	PRODUCTS_AND_SERVICE: "/products-and-service",
	NEWS: "/news",
	NEWS_SINGLE: (slug: string) => `/news/${slug}`,
	CONTACT: "/contact",
	PRIVACY_POLICY: "/privacy-policy",
	RELATIVE: (relativePath: string) => relativePath,
};

export const getNavItems = () => {
	return [
		{ href: ROUTES.ABOUT, label: LABELS.about },
		{ href: ROUTES.PRODUCTS_AND_SERVICE, label: LABELS.productsAndService },
		{ href: ROUTES.NEWS, label: LABELS.news },
		{ href: ROUTES.CONTACT, label: LABELS.contact },
	];
};
